
  export default {
    props: {
      value: {
          type: String,
          default: ''
      },
      label: {
          type: String,
          default: "Write text",
      },
      type: {
          type: String,
          default: ''
      },
      disabled: {
          type: Boolean,
          default: false
      },
    },
    methods: {
        checkValue(e) {
            if (e.target.value.length > 0){
                this.$el.classList.add('has-value');
            } else {
                this.$el.classList.remove('has-value');
            }
        }
    },
  };

